<template>
<div class="chapter">
<div class="inner_page">
<p class="epi" id="epigraph"><a id="pVI"></a>Men and women find universally, (however the fact may be concealed,) that their susceptibility to love is not burnt out by one honey-moon, or satisfied by one lover. On the contrary, the secret history of the human heart will bear out the assertion that it is capable of loving any number of times and any number of persons, and that the more it loves the more it can love. This is the law of nature, thrust out of sight, and condemned by common consent, and yet secretly known to all.</p>
<p class="epi-qr">John Humphrey Noyes, “Bible Argument”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?932ad600